module.exports = __webpack_public_path__ + "static/media/top.19914a62.png";